/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { InboxsRouting } from './inbox.routing';
interface Props {}

export const InboxsComponent = memo((props: Props) => {
  return (
    <>
      <div></div>
      <InboxsRouting />
    </>
  );
});

export const InboxsModule = lazyLoad(
  () => import('./inbox.module'),
  (module) => module.InboxsComponent
);
